import {
  Box,
  Button,
  Collapse,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Typography,
  useTheme,
} from '@mui/material';
import { StyledMapAlert, alertList, alertMessage, listItemText } from '../map/styles';
import { useState } from 'react';
import { MapArrowUpIcon } from 'src/assets/icons/MapArrowUpIcon';
import { MapArrowDownIcon } from 'src/assets/icons/MapArrowDownIcon';
import { CloseIcon } from 'src/assets/icons/CloseIcon';
import { WarningIcon } from 'src/assets/icons/WarningIcon';
import { NewSite } from 'src/types/sites/sites';

export const MissingCoordinatesMessage = ({ siteData }: { siteData: NewSite[] }) => {
  const [open, setOpen] = useState(true);
  const [expanded, setExpanded] = useState(false);

  const theme = useTheme();

  const onClose = () => {
    setOpen(false);
  };

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  return (
    <Collapse in={open}>
      <StyledMapAlert
        severity="warning"
        variant="standard"
        action={
          <Box sx={{ display: 'flex' }}>
            <Button
              sx={{ marginRight: '8px', minWidth: 'max-content' }}
              variant="text"
              color="inherit"
              endIcon={expanded ? <MapArrowUpIcon /> : <MapArrowDownIcon />}
              onClick={handleExpandClick}
              data-testid="show-hide-button"
            >
              {expanded ? 'Hide missing sites' : 'Show missing sites'}
            </Button>
            <IconButton aria-label="close" color="inherit" size="small" onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </Box>
        }
      >
        <Box sx={alertMessage}>
          <WarningIcon fill={theme.palette.warning.main} />
          <Typography variant="body1" color="warning.darker" data-testid="missing-coordinates">
            <b> {siteData.length} of your sites </b> can not be displayed due to missing
            coordinates. Admins can add them under Settings / Site Info.
          </Typography>
        </Box>
        <Collapse in={expanded} timeout="auto" unmountOnExit>
          <List dense={true} sx={alertList} data-testid="notification-sites-list">
            {siteData.map((site: NewSite) => (
              <ListItem key={site.id} sx={{ color: theme.palette.warning.darker }}>
                <ListItemText primary={site.siteName} sx={listItemText} />
              </ListItem>
            ))}
          </List>
        </Collapse>
      </StyledMapAlert>
    </Collapse>
  );
};
